import { H2 } from '@/common/ui'
import { Dialog, DialogContent } from '@/common/ui/dialog'
import { Spinner } from '@/common/ui/spinner'
import { ONBOARDING_COPY } from '@/locales/en'
import { FC } from 'react'

type OnboardingRedirectModalProps = {
    open: boolean
    onClose?: () => void
}

export const OnboardingRedirectModal: FC<OnboardingRedirectModalProps> = ({ open, onClose }) => (
    <Dialog open={open}>
        <DialogContent
            onClose={onClose}
            className="
        max-w-[600px] w-full
        flex flex-col items-center justify-center
        px-10 py-12
        bg-white
        rounded-tl-[96px] rounded-tr-[16px] rounded-br-[96px] rounded-bl-[16px]
        gap-12
      "
        >
            <div className="flex flex-col items-center gap-6 w-full">
                <div className="flex flex-col items-center gap-6 w-full">
                    {/* Conic-gradient circle */}
                    <div className="relative" style={{ width: 64, height: 64 }}>
                        <Spinner size="lg" />
                    </div>
                    <H2 className="w-full text-center text-[30px] font-normal leading-9 text-[#223A32]">
                        {ONBOARDING_COPY.redirect}
                    </H2>
                </div>
            </div>
        </DialogContent>
    </Dialog>
)
